var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        disappear: _vm.animation_status === 2 || _vm.animation_status === 4,
      },
      attrs: { id: "st_sidebar" },
    },
    [
      _c(
        "div",
        { staticClass: "sidebar_list st_scroll", class: { top: _vm.top } },
        _vm._l(_vm.Drop, function (item, index) {
          return item.dataName != 0
            ? _c("div", { key: index, staticClass: "sidebar_list_item" }, [
                _c("div", { staticClass: "item_main" }, [
                  _c("div", {
                    staticClass: "edge",
                    style: _vm._f("edgeColor")(item.imageData),
                  }),
                  _c("div", { staticClass: "item_core" }, [
                    _c("div", { staticClass: "pic" }, [
                      _c("img", { attrs: { src: item.userIcon, alt: "" } }),
                    ]),
                    _c(
                      "div",
                      { staticClass: "item_data" },
                      [
                        _c(
                          "Tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: item.goodsName,
                              placement: "bottom",
                            },
                          },
                          [
                            _c("p", { staticClass: "hide" }, [
                              _vm._v(_vm._s(item.goodsName)),
                            ]),
                          ]
                        ),
                        _c("span", [_vm._v(_vm._s(item.price))]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ])
            : _vm._e()
        }),
        0
      ),
      _c("div", { staticClass: "switch" }, [
        _c("div", { staticClass: "pic", on: { click: _vm.to_warehouse } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.scrape > 0,
                  expression: "scrape > 0",
                },
              ],
              staticClass: "counter",
            },
            [_vm._v(_vm._s(_vm.scrape))]
          ),
          _c("img", {
            attrs: {
              src: require("../../../resources/images/commom/knapsack.png"),
              alt: "",
            },
          }),
        ]),
        _c(
          "p",
          {
            on: {
              click: function ($event) {
                _vm.top = !_vm.top
              },
            },
          },
          [_vm._v("最近掉落"), _c("i", { class: { top: _vm.top } })]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }